export default {
  header: {
    title: 'Geschenkkarte kaufen',
  },
  items: {
    gift_card: {
      label: 'Geschenkkarte',
      title: 'Wähle den gewünschten Betrag',
      description: 'Füge die Geschenkkarte mit dem gewünschten Betrag zum Warenkorb hinzu',
    },
    expiration: {
      label: 'Gültig für 3 Jahre',
      title: 'Viel Spaß beim Verschenken!',
      description: 'Der Empfänger kann den Gutschein flexibel innerhalb von 3 Jahren einlösen.',
    },
    delivery: {
      label: 'Sofortige Lieferung als PDF per E-Mail',
      title: 'Sofortige Lieferung als PDF per E-Mail',
      description: 'Nach erfolgreicher Zahlung per Kreditkarte, PayPal oder giropay erhältst du den Gutschein sofort.',
    },
  },
  form: {
    value: {
      title: 'Wähle den Betrag der Geschenkkarte',
      custom: {
        label: 'Benutzerdefiniert',
        placeholder: 'Betrag eingeben',
      },
    },
    quantity: {
      title: 'Menge',
    },
    email: {
      title: 'Was ist deine E-Mail-Adresse, damit wir dir die Geschenkkarte zusenden können?',
      placeholder: 'Deine E-Mail-Adresse',
    },
  },
  confirmation: {
    title: {
      title: 'Geschenkkarte erstellen?',
      subtitle_one: 'Möchtest du 1 Geschenkkarte für {{value}} erstellen?',
      subtitle_other: 'Möchtest du {{count}} Geschenkkarten für {{value}} erstellen?',
    },
    description: {
      total: 'Gesamt:',
      email: 'E-Mail:',
      quantity: 'Menge',
      amount: 'Betrag',
    },
    footer: {
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
    },
  },
  buttons: {
    create: 'Erstellen',
  },
  toasts: {
    error: 'Erstellung der Geschenkkarte fehlgeschlagen.',
    success: 'Geschenkkarte erfolgreich erstellt.',
  },
};
